<template>
    <PanelPage>
        <template v-slot:title>
            <SmartBreadcrumbs
                type="InertiaLink"
                :pages="[
                    {
                        name: $tc('messages.activities', 2),
                        href: meta.links.index,
                    },
                    {
                        name: activity.title,
                        href: meta.links.show,
                    },
                    {
                        name: $tc('messages.grades', 2),
                        href: null,
                    },
                ]"
            />
        </template>

        <AlertMessage class="mt-5 inline-block" type="info" v-if="attempt">
            <template v-slot:title>
                {{ $t('messages.information') }}
            </template>
            <template v-slot:body>
                <div class="flex items-center gap-x-2">
                    <span>{{ $t('messages.viewing_single_activity_attempt') }}</span>
                    <AppButton element="InertiaLink" :href="meta.links.responses_show" desired-action>
                        {{ $t('messages.show_all') }}
                    </AppButton>
                </div>
            </template>
        </AlertMessage>

        <div v-if="activity.quiz.recalculate_score_at">
            <AlertMessage class="mt-5 inline-block" type="info">
                <template v-slot:title>
                    {{ $t('messages.information') }}
                </template>
                <template v-slot:body>
                    {{ $t('messages.quiz_scores_will_be_recalculated_at') }}: {{ activity.quiz.recalculate_score_at }}
                </template>
            </AlertMessage>
        </div>

        <QuizReview :activity="activity" :questions="questions" :students="students" mode="teacher" />
    </PanelPage>
</template>

<script>
import Layout from '@/Shared/Layout.vue';
import PanelPage from '@/Shared/PanelPage.vue';
import QuizReview from '@/components/QuizReview.vue';
import AlertMessage from '@/components/AlertMessage.vue';
import AppButton from '@/components/AppButton.vue';
import MedallionLevels from '@/components/MedallionLevels.vue';

export default {
    components: {
        MedallionLevels,
        AppButton,
        AlertMessage,
        QuizReview,
        PanelPage,
    },
    layout: Layout,
    name: 'Show',
    props: ['meta', 'options', 'questions', 'activity', 'students', 'attempt'],
    data() {
        return {
            show: 'score',
            displayOptions: [
                { text: this.$tc('messages.scores', 2), value: 'score' },
                { text: this.$tc('messages.letters', 2), value: 'letter' },
            ],
            scoredStudents: this.students.filter((s) => s.done),
        };
    },
    methods: {
        selectAllStudents() {
            this.scoredStudents.forEach((s) => (s.is_selected = true));
        },
        deselectAllStudents() {
            this.scoredStudents.forEach((s) => (s.is_selected = false));
        },
    },
    computed: {
        filteredStudents: function () {
            return this.scoredStudents.filter((s) => s.is_selected);
        },
    },
};
</script>
